import { render, staticRenderFns } from "./iconBathtub.vue?vue&type=template&id=61d6cd26"
import script from "./iconBathtub.vue?vue&type=script&lang=js"
export * from "./iconBathtub.vue?vue&type=script&lang=js"
import style0 from "./iconBathtub.vue?vue&type=style&index=0&id=61d6cd26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports